/* ==========================================================================
   Terlato Kitchen — Corporate Gifting hub · band 3 "Curated Boxes"
   sections/gf-corp-hub-boxes.liquid

   One job: turn "Add to Gift Plan" into a prefill of the in-page plan form.

   THIS IS NOT AN ADD-TO-CART. It writes the chosen gift box into the shared
   client-side store (window.GFCorpPlan, assets/gf-corp-plan.js), announces the
   change on the polite live region, then scrolls to the plan form and parks
   focus there. No cart call, no network call, no Shopify endpoint — a
   corporate quote is not an order (PLAN §4.1).

   Progressive enhancement: the button is a real <a href="#gf-corp-hub-plan">.
   With this script absent or GFCorpPlan missing, the click still lands the
   visitor on the form; the anchor's own jump is the fallback and is never
   cancelled unless we have somewhere better to send them.
   ========================================================================== */

(function (window, document) {
  'use strict';

  var ROOT_SEL = '[data-gf-corp-boxes]';
  var ADD_SEL = '[data-gf-corp-add]';
  var DEFAULT_ANCHOR = '#gf-corp-hub-plan';
  var DEFAULT_TEMPLATE = '[box] added to your gift plan.';

  function api() {
    return window.GFCorpPlan || null;
  }

  function attr(el, name) {
    var v = el.getAttribute(name);
    return v === null || v === '' ? null : v;
  }

  function numOrNull(v) {
    if (v === null || v === undefined || v === '') return null;
    var n = parseFloat(v);
    return isFinite(n) ? n : null;
  }

  function boxFrom(button) {
    return {
      title: attr(button, 'data-gf-box-title') || '',
      productHandle: attr(button, 'data-gf-box-handle'),
      variantId: attr(button, 'data-gf-box-variant'),
      unitPrice: numOrNull(attr(button, 'data-gf-box-price'))
    };
  }

  /* Block settings, not user state. gf-corp-plan.js re-reads the catalogue from
     Liquid on every load and never persists it, so buildPayload() can fill in
     the handle / variant / price the summary never asked the visitor for. */
  function registerCatalogue(root) {
    var plan = api();
    if (!plan || !plan.registerGiftBox) return;
    var buttons = root.querySelectorAll(ADD_SEL);
    for (var i = 0; i < buttons.length; i++) {
      var box = boxFrom(buttons[i]);
      if (!box.title) continue;
      plan.registerGiftBox(box.title, {
        productHandle: box.productHandle,
        variantId: box.variantId,
        unitPrice: box.unitPrice,
        url: attr(buttons[i], 'data-gf-box-url')
      });
    }
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Move focus to the plan form without letting focus() fight scrollIntoView.
     The form owns [data-gf-plan-focus] when it wants a specific control; the
     section root is the fallback and is made programmatically focusable only. */
  function focusPlan(target) {
    var focusTarget = target.querySelector('[data-gf-plan-focus]') || target;
    if (!focusTarget.hasAttribute('tabindex')) {
      focusTarget.setAttribute('tabindex', '-1');
    }
    try {
      focusTarget.focus({ preventScroll: true });
    } catch (e) {
      focusTarget.focus();
    }
  }

  function onClick(root, event) {
    var button = event.target.closest ? event.target.closest(ADD_SEL) : null;
    if (!button || !root.contains(button)) return;

    var plan = api();
    var box = boxFrom(button);

    if (plan && box.title) {
      plan.setGiftBox(box);
      var template = root.getAttribute('data-gf-added-template') || DEFAULT_TEMPLATE;
      plan.announce(template.split('[box]').join(box.title));
    }

    var anchor = root.getAttribute('data-gf-plan-anchor') || DEFAULT_ANCHOR;
    var target = null;
    try {
      target = anchor.charAt(0) === '#' ? document.querySelector(anchor) : null;
    } catch (e) {
      target = null;
    }

    /* No plan form on this page (a standalone band render, or the CTA has been
       repointed at the wizard) — leave the anchor to do whatever it does. */
    if (!target) return;

    event.preventDefault();
    try {
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
    } catch (e) {
      target.scrollIntoView();
    }
    focusPlan(target);
  }

  function bind(root) {
    if (root.gfCorpBoxesBound) {
      registerCatalogue(root);
      return;
    }
    root.gfCorpBoxesBound = true;
    root.addEventListener('click', function (event) { onClick(root, event); });
    registerCatalogue(root);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* The store may finish booting after us on a page where another section
     emitted gf-corp-plan.js first; re-register rather than lose the catalogue. */
  document.addEventListener('gf-corp-plan:ready', function () { init(); });

  /* Theme editor: a re-rendered section arrives with fresh nodes. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})(window, document);
